const PLAN_AND_BILLING_AREAS = ['plan', 'subscription'];

/**
 * Whether a path is one of the billing routes -- `/{orgCode}/settings/plan` or
 * `/{orgCode}/settings/subscription`. The counterpart of
 * `CspPlanAndBillingZone.IsPlanAndBillingPath`, which has to answer alike -- see its doc comment.
 */
export function isPlanAndBillingPath(path: string): boolean {
	if (!path)
		return false;

	const segments = path.split('/').filter(Boolean).map(segment => segment.toLowerCase());

	if (segments.length < 3 || segments[1] !== 'settings')
		return false;

	return PLAN_AND_BILLING_AREAS.includes(segments[2]);
}

/**
 * Whether the running document is an isolated billing document. Anything that must stay off the billing
 * surface asks this rather than inspecting the current route, since it is answerable at module evaluation
 * time, before the router has resolved anything.
 */
export function isPlanAndBillingDocument(): boolean {
	return isPlanAndBillingPath(location.pathname);
}

/**
 * Whether a navigation moves into or out of the billing routes. Such a navigation has to be made as a
 * full page load rather than a client-side transition, so that billing gets its own document and the
 * response headers that go with it. The guard that acts on this must be registered before any other
 * navigation guard, since a crossing has to short-circuit the navigation rather than let it proceed.
 */
export function isPlanAndBillingBoundaryCrossing(toPath: string, fromPath: string, isInitialLoad: boolean): boolean {
	if (isInitialLoad)
		return false;

	return isPlanAndBillingPath(toPath) !== isPlanAndBillingPath(fromPath);
}
